// extracted by mini-css-extract-plugin
export const root = "author-list-module--root--3tnc7";
export const headline = "author-list-module--headline--3BVPD typography-module--base--2DtHq";
export const list = "author-list-module--list--1awEt";
export const listItem = "author-list-module--listItem--13pbd";
export const avatar = "author-list-module--avatar--3sDy5";